import toastr from "toastr";

/*
 * El teléfono del huésped al crear una reserva a mano.
 *
 * 🚨 El campo nace con el prefijo del país del hotel ya escrito. A una huésped alemana
 * de un hotel sueco se le guardó +46 1716700263 en vez de +49 1716700263: el número
 * no existía, Meta rechazó todos sus WhatsApp (131026) y nadie se enteró. La librería
 * ya sabía que no era un número sueco válido, pero solo se miraba que tuviera 5 cifras.
 *
 *  · Si el número no es válido para el país elegido, se avisa UNA vez al guardar; el
 *    segundo clic guarda igual (México con el «+52 1…» antiguo sale «no válido», y
 *    bloquearlo dejaría sin crear reservas a quien lo use).
 *  · Si con el prefijo ya puesto pegan otro internacional («+46» + «+49…» o «0049…»),
 *    se queda el que pegaron.
 *
 * El componente pone <vue-tel-input @input="alCambiarTelefono"> y, si su teléfono no
 * vive en `form.phone`, sobrescribe ponerTelefono().
 */

/** «+46+491716700263» o «+460049…» → «+491716700263»; si no, null. */
export function rescatarInternacional(valor, prefijo) {
  const s = String(valor || "").replace(/[\s()-]+/g, "");
  if (!prefijo || !s.startsWith(`+${prefijo}`)) return null;
  const resto = s.slice(String(prefijo).length + 1);
  return /^(\+|00)\d{6,}$/.test(resto) ? `+${resto.replace(/^(\+|00)/, "")}` : null;
}

export default {
  data() {
    return {
      telefonoValido: true,
      telefonoAvisado: false,
      telefonoPais: "",
    };
  },

  methods: {
    alCambiarTelefono(valor, objeto) {
      this.telefonoAvisado = false;
      const pais = (objeto && objeto.country) || {};
      const rescatado = rescatarInternacional(valor, pais.dialCode);
      if (rescatado) {
        this.$nextTick(() => this.ponerTelefono(rescatado));
        return;
      }
      // `valid` viene undefined mientras el campo está vacío o a medias: eso no es «mal».
      this.telefonoValido = !objeto || objeto.valid !== false;
      this.telefonoPais = pais.name ? `${pais.name} (+${pais.dialCode})` : "";
    },

    ponerTelefono(valor) {
      this.form.phone = valor;
    },

    /** true = parar el guardado y avisar (solo la primera vez). */
    telefonoParaRevisar() {
      if (this.telefonoValido || this.telefonoAvisado) return false;
      this.telefonoAvisado = true;
      toastr.warning(
        this.$t("reservasHc.telefonoDelHuesped.noValido", { pais: this.telefonoPais || "?" }),
        "",
        { timeOut: 10000 }
      );
      return true;
    },
  },
};
